const mustHaveOptions =
{
    typography:
    {
        htmlFontSize: 9 // 10
    }
};

export default mustHaveOptions ;